import Lottie from "lottie-react";
import LottieIcon from "./SendFileAnimation.json";

const SendFileAnimationComponent = ({ className }) => {
  return (
    <Lottie
      animationData={LottieIcon}
      loop={false}
      autoplay={true}
      className={`tw-w-12  ${className ?? ""}`}
    />
  );
};

export default SendFileAnimationComponent;
